import React from "react";

export default function Upload() {
  return <div className="text-white">this is upload page</div>;
}
